<template>
  <div class="column_center_around order_method_container">
    <!-- <div v-if="storeHasDineInTables" class="table_select" :class="tableName ? 'row_center_center' : 'row_center_between'" @click="showTableOption = true">
      <text class="text-center font-normal" :class="tableName ? 'text-black' : 'text-[rgba(0,0,0,0.3)]'">{{ tableName || '請選擇桌號' }}</text>
      <text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;"
        v-if="!tableName">expand_more</text>
    </div> -->
    <!--
    <button class="button" @click="toOrderPage">開始點餐</button>
    -->
    <button class="button" @click="toOrderPage">外帶點餐</button>
    <div class="w-full mt-5 mb-2 row_center_center" v-if="toGoDelayMinute !== 0">
      現場外帶需等候{{ toGoDelayMinute }}分鐘
    </div>
    <SelectDineInTable :tableOptions="dineInTables" v-if="showTableOption" @close="showTableOption = false" @setTable="setTableData" />
  </div>
</template>
<script>
import selectDineInTable from "./selectDineInTable.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    SelectDineInTable: selectDineInTable,
  },
  data() {
    return {
      tableData: {},
      showTableOption: false
    };
  },
  computed: {
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    dineInTables() {
      return this.$store.getters['spreadsheet/dineInTables']
    },
    tableIndex() {
      return this.$store.getters['cart/tableIndex']
    },
    storeHasDineInTables() {
      return this.dineInTables.length >= 1
    },
    ...mapGetters('cart', {
      tableName: 'tableName',
      tableAreaId: 'tableAreaId',
      tableIndex: 'tableIndex',
    }),
    ...mapGetters('basic', {
      toGoDelayMinute: 'toGoDelayMinute',
      toGoDelayHour: 'toGoDelayHour'
    })
  },
  methods: {
    toOrderPage() {
      if (!this.areaId || !this.tableName) {
        const data = {
            areaId: null,
            tableIndex: -1
        }
        console.log('to go table selection', data)
        this.$store.commit('cart/setTableData', data)
      }
      const data = {
        method: 'takeOut'
      }
      this.$emit('toOrderPage', data)
    },
  },
};
</script>
<style lang="scss" scoped>
.table_select {
  width: 100%;
  height: 54px;
  padding: 0 4%;
  border: #AAAAAA 1px solid;
  border-radius: 6px;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  font-family: PingFang SC;
  margin: 18px 0 15px;
}
</style>
